export const PLACEHOLDER_TEXT = 'Select date range';
